import { createContext, useContext } from "react";
import { StorageApiUploadOptions } from "../utils/storageApiUploadOptions";

const Context = createContext<StorageApiUploadOptions | null>(null);

export const useStorageApiUploadOptions = () => useContext(Context);

export const StorageApiUploadOptionsProvider = Context.Provider;
